import * as React from 'react';
import { Layout } from '../components/layout';
import { Certificados } from '../pages/certificados/certificados';
import AberturaChamado from '../pages/abertura-chamado/abertura-chamado';

const headerProps = {
  name: 'Chatbot EAD',
};

export const ClientRoutes = [
  {
    routePath: '/certificados',
    isExactPath: true,
    pageToRender: (
      <React.Fragment>
        <Layout headerProps={headerProps}>
          <Certificados />
        </Layout>
      </React.Fragment>
    ),
  },
  {
    routePath: '/abertura-chamado',
    isExactPath: true,
    pageToRender: (
      <Layout>
        <AberturaChamado />
      </Layout>
    ),
  },
];
